export default "__VITE_ASSET__DELS$a1v__"